import { Box, Flex, HStack, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import TrackSraDetails from '../Components/TrackSraDetails'
import MainLayout from '../Layouts/Index'
import { AllSraProduct, AllUser, UpdateUserApi } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'
import { AiOutlinePlus } from 'react-icons/ai'
import CreateUser from '../Components/CreateUser'

export default function UserManagement() {
    const [Data, setData] = useState([]);
    const [SingleData, setSingleData] = useState([]);
    const [ModalType, setModalType] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const [PreLoader, setPreLoader] = useState(true);


    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentSra = Data.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }




    const AllUsers = async () => {
        setPreLoader(true)
        let result = await AllUser()

        console.log("AllUsers", result);

        if (result.status === true) {
            setData(result.queryresult.userdetails)
            setPreLoader(false)
        } else {

            setPreLoader(false)
        }
    }
    const UpdateUsers = async (id) => {
        setPreLoader(true)
        let result = await UpdateUserApi(id)

        console.log("UpdateUsers", result);

        if (result.status === true) {
            AllUsers()
            setPreLoader(false)
        } else {

            setPreLoader(false)
        }
    }





    const [SearchText, setSearchText] = useState("");
    const [SelectStore, setSelectStore] = useState("");



    // const moreDetails = (id) => {

    //     let singleInfo = Data.filter((item, i) => {
    //         return item._id === id
    //     })
    //     setSingleData(singleInfo)
    //     onOpen()
    // }

    const handleSelectStore = (e) => {
        setSelectStore(e.target.value)




    }

    const handleNewUser = () => {
        setModalType("new")
        onOpen()
    }
    
    const updateUser = (id)=>{
        
        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })
        
        setModalType("update")
        
        setSingleData(singleInfo)
        onOpen()

      


    } 


    useEffect(() => {
        AllUsers()

    }, [isOpen])
    return (
        <MainLayout>
            {
                PreLoader && (

                    <Preloader />
                )
            }
            <Seo title="User Management" description='Eko User Management' />
            <Flex justifyContent={"space-between"} flexWrap="wrap" fontWeight={"500"} >


                <HStack onClick={handleNewUser} cursor={"pointer"} _hover={{ color: "blue.blue600" }}>
                    <Box>
                        <AiOutlinePlus />
                    </Box>
                    <Text >Create User</Text>

                </HStack>
                <Text textTransform="capitalize">Total Numbers of Users - {Data.length}</Text>

            </Flex>

            <Flex justifyContent="space-between" flexWrap="wrap" alignItems="center">
                <Box w={["100%", "100%", "100%", "100%", "48%"]}>

                    <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"productName, ProductShelfId, Status"} />
                </Box>


                <Select w={["100%", "100%", "100%", "100%", "48%"]} borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={SelectStore != "" ? "16px" : "12px"} id='store' value={SelectStore} onChange={handleSelectStore}>

               
                    <option value="2" >Central Circle stores, Ijora</option>
                    <option value="3" >East Circle stores, Island</option>
                    <option value="4" >West Circle stores, Festac</option>
                    <option value="9" >Technical Emergency </option>

                </Select>
            </Flex>
            <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

                <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

                >
                    <Table variant='simple' size='sm' overflowX="auto" >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">User's email</Th>
                                <Th color="#fff">User's Store</Th>
                                <Th color="#fff">User's Type</Th>
                                <Th color="#fff">Status</Th>
                                <Th color="#fff">Update Status</Th>
                                <Th color="#fff">Update User</Th>


                            </Tr>
                        </Thead>
                        <Tbody>

                            {

                                SelectStore === "" ? (
                                    SearchText === "" ? (
                                        currentSra.map((item, i) => (
                                            <TableRow
                                                type={"techUser"}
                                                sn={i + 1}
                                                email={item.email}
                                                store={item.store}
                                                status={item.status}
                                                userType={item.usertype}
                                                update={()=>updateUser(item._id)}
                                                onClick={()=>UpdateUsers(item._id)}


                                            />
                                        ))
                                    ) : (
                                        SearchText !== "" && Data.filter(item => item.shelfid?.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.shelfid?.productshelfid.toLowerCase().includes(SearchText.toLowerCase()) || item.status.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (
                                            Data.filter(item => item.shelfid?.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.shelfid?.productshelfid?.toLowerCase().includes(SearchText.toLowerCase()) || item.status.toLowerCase().includes(SearchText.toLowerCase()))
                                                .map((item, i) => (
                                                    <TableRow
                                                        type={"techUser"}
                                                        sn={i + 1}
                                                        email={item.email}
                                                        store={item.store}
                                                        status={item.status}
                                                        userType={item.usertype}
                                                        update={()=>updateUser(item._id)}
                                                        onClick={()=>UpdateUsers(item._id)}

                                                    />
                                                ))
                                        ) : (


                                            <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                                        )

                                    )
                                ) : (
                                    Data.filter(item => item.store === SelectStore)
                                        .map((item, i) => (
                                            <TableRow
                                                type={"techUser"}
                                                sn={i + 1}
                                                email={item.email}
                                                store={item.store}
                                                status={item.status}
                                                userType={item.usertype}
                                                update={()=>updateUser(item._id)}
                                                onClick={()=>UpdateUsers(item._id)}

                                            />
                                        ))
                                )



                            }


                        </Tbody>

                    </Table>
                </TableContainer>


                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />

                <CreateUser isOpen={isOpen} onClose={onClose} state={ModalType} singleData={SingleData} />

            </Box>


        </MainLayout>
    )
}
